<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer001">
<p class="halftitle">A LITTLE MORE FREE</p>
<p class="tp2">AN EDDIE DOUGHERTY MYSTERY</p>
<p class="tp3">JOHN McFETRIDGE</p>
<p class="tp2">ECW PRESS</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?0ab607a4